module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/banner--rules-41e57d3926d84972ec5e7665b9e2807e.jpg";